import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SharePanelProps} from '@Panels/share-panel/share-panel.types';

export const openSharingModal = (props: SharePanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SHARE_MODAL,
      panelProps: props,
    }),
  );
};